import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

interface PaginationObj {
  itemsPerPage: number;
  currentPage: number;
  itemCount: number;
}

@Injectable()
export class PaginationService {
  protected paginationObj: PaginationObj;
  subject: BehaviorSubject<PaginationObj>;
  constructor() {
    this.paginationObj = {itemsPerPage: 20, currentPage: 1, itemCount: 0};
    this.subject = new BehaviorSubject(this.paginationObj);
  }
  public getItemsPerPage() {
    return this.paginationObj.itemsPerPage;
  }
  public getSubject() {
    return this.subject;
  }
  public setItemCount(itemCount: number) {
    this.paginationObj.itemCount = itemCount;
    this.subject.next(this.paginationObj);
  }
  public setItemsPerPage(itemsPerPage: number) {
    this.paginationObj.itemsPerPage = itemsPerPage;
    this.subject.next(this.paginationObj);
  }
  public setCurrentPage(currentPage) {
    this.paginationObj.currentPage = currentPage;
    this.subject.next(this.paginationObj);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pagination.service.ts